import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { DialogRef, ModalComponent } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { CardDetails, SendMoneyDetail, StoreDetails } from '../../../models/sendmoney/sendmoney';
import { AlertService } from '../../../sharedcomponents/commonservice/alert.service';
import { CountryService } from '../../../sharedcomponents/commonservice/countrylist.service';
import { utilityService } from '../../../sharedcomponents/commonservice/utility.service';
import { SendMoneyService } from '../../../_services/sendmoneyservice/sendmoneyservice';
export class CustomModalContext extends BSModalContext {
  public modalData: any;
}
@Component({
  selector: 'app-store-popup',
  templateUrl: './store-popup.component.html',
  providers: [AlertService, Modal, CountryService]
})
export class storedetailmodalcomponent implements OnInit, ModalComponent<CustomModalContext> {
  storepopupData: any = {};
  context: CustomModalContext;
  sendMoneyDetail: SendMoneyDetail;
  storeImageURL: string = '';
  constructor(
    public dialog: DialogRef<CustomModalContext>,
    private router: Router,
    private sendMoneyService: SendMoneyService,
    public utilityServ: utilityService,
    public translate: TranslateService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
    this.context = dialog.context;
  }
  ngOnInit() {
    this.storepopupData = this.context.modalData;
    this.sendMoneyDetail = new SendMoneyDetail();
    this.sendMoneyService.getSendMoneyDetailData().subscribe(data => {
      this.sendMoneyDetail = data;
    });
    // no further use as per client mail FW: APP Issues and changes Dated Thu 6/6/2019 9:17 PM
    // this.utilityServ.busy = this.sendMoneyService.getstoreimage(this.utilityServ.getObjectText(this.storepopupData.StoreID)).subscribe(
    //   data => {
    //     if (data.Envelope.Body.AgentStoreImageResponse.StatusCode == 1000 || data.Envelope.Body.AgentStoreImageResponse.StatusCode == 10021) {
    //       // Image not founde
    //       this.storeImageURL = 'data:image/gif;base64,' + data.Envelope.Body.AgentStoreImageResponse.StoreImageData;
    //     }
    //   },
    //   error => {
    //     console.log('Unable to get Store Image, Something went wrong' + error);
    //   }
    // );
  }

  moreInfoClick() {
    this.payAtStoreClick(this.storepopupData);
    this.context.modalData.next = 'moreInfo';
    this.dialog.close();
  }

  continueStoreClick() {
    this.payAtStoreClick(this.storepopupData);
    this.context.modalData.next = 'continue';
    this.dialog.close();
  }

  initializestore(obj) {

    const storeDetails: StoreDetails = new StoreDetails();
    storeDetails.storeId = this.utilityServ.getObjectText(obj.StoreID);
    // storeDetails.storeaddress = obj.Address;
    storeDetails.storeaddress.Address1 = this.utilityServ.getObjectText(obj.Address.Address1);
    storeDetails.storeaddress.CityCode = this.utilityServ.getObjectText(obj.Address.City);
    storeDetails.storeaddress.CountryCode = this.utilityServ.getObjectText(obj.Address.CountryCode);
    storeDetails.storeaddress.Latitude = this.utilityServ.getObjectText(obj.Address.Latitude);
    storeDetails.storeaddress.Longitude = this.utilityServ.getObjectText(obj.Address.Longitude);
    storeDetails.storeaddress.StateCode = this.utilityServ.getObjectText(obj.Address.StateCode);
    storeDetails.storeaddress.ZipCode = this.utilityServ.getObjectText(obj.Address.ZipCode);
    storeDetails.storeName = this.utilityServ.getObjectText(obj.Name);
    storeDetails.storenotesSection = this.utilityServ.getObjectText(obj.Notes);
    storeDetails.storespecialInstructionSection = this.utilityServ.getObjectText(obj.SpecialInstructions);
    //storeDetails.storeOpeningTime =this.utilityServ.getObjectText(obj.storeOpeningTime);
    storeDetails.storedirections = this.utilityServ.getObjectText(obj.Directions);
    storeDetails.storedistance = this.utilityServ.getObjectText(obj.Distance);
    storeDetails.storemail = this.utilityServ.getObjectText(obj.Email);
    storeDetails.storeLimitations = this.utilityServ.getObjectText(obj.Limitations);
    storeDetails.storePhoneNumber = this.utilityServ.getObjectText(obj.PhoneNumber);
    storeDetails.storeRestrictions = this.utilityServ.getObjectText(obj.Restrictions);
    storeDetails.storeScheduleThisWeekThisWeek = this.utilityServ.getObjectText(obj.TimeForThisWeek);

    storeDetails.storeimageurl = this.storeImageURL;
    return storeDetails;
  }
  payAtStoreClick(obj) {
    this.sendMoneyDetail.paymentDetails.fundingId = 0;
    const cardDetails: CardDetails = new CardDetails();
    this.sendMoneyDetail.cardDetails = cardDetails;
    const storeDetails: StoreDetails = this.initializestore(obj);
    this.sendMoneyDetail.storeDetails = storeDetails;
    this.sendMoneyService.setSendMoneyDetailData(this.sendMoneyDetail);
    this.sendMoneyService.setStoreDetailData(storeDetails);
  }

  closeClick() {
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/sendMoney/_modalpopup/store-popup/store-popup.component.ts